/* istanbul ignore file */
import { FormRow, FormSection } from 'framework/ui/layout';
import { useEffect } from 'react';
import { CurrencyInput, useFormContext } from 'framework/form';
import { CurrencyDropdown } from 'domain/shared/core/input';
import compensationFormValidationSchema from './compensationFormValidationSchema';
import RegistrationLocationDropdown from '../../input/RegistrationLocationDropdown';
import { SubmitButton } from 'framework/ui/ui-builder';
import { Button } from 'framework/ui/mui-builder';
import { REGISTRATION_LOCATION } from '../../../types';
import { CURRENCY_TYPES } from 'domain/shared/core/constants';
import { Box } from '@mui/material';

interface CompensationFormProps {
  handleCancelClick: () => void;
}

const CompensationForm = ({ handleCancelClick }: CompensationFormProps) => {
  const { submitForm, isSubmitEnabled, isLoadingArtifact, setValidationSchemaAction } = useFormContext();

  useEffect(() => {
    if (setValidationSchemaAction) {
      setValidationSchemaAction(compensationFormValidationSchema);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <FormSection title="Expected Compensation">
        <FormRow>
          <CurrencyInput source="compensationFromValue" label="From" isRequired />
          <CurrencyInput source="compensationToValue" label="To" isRequired />
          <CurrencyDropdown source="compensationCurrency" options={CURRENCY_TYPES} label="Currency" />
          <RegistrationLocationDropdown
            source="location"
            options={REGISTRATION_LOCATION}
            label="Registration location"
          />
        </FormRow>
      </FormSection>

      <Box display="flex" gap={1.25}>
        <SubmitButton
          key="submit-modal-btn"
          onClick={submitForm}
          isLoading={!isSubmitEnabled}
          disabled={isLoadingArtifact}
        />
        <Button
          variant="outlined"
          key="cancel-modal-btn"
          onClick={handleCancelClick}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Cancel
        </Button>
      </Box>
    </>
  );
};

export default CompensationForm;
